<template>
  <!-- Row: Chart -->
  <div class="row f-row table_chart_height mt-1" style="overflow-y: auto;">
    <div class="row f-row" style="height:100%; width:100%;">
      <div class="col col-12">
        <div style="padding: 0 40px;">
          <table class="table table-sm table-borderless curve_analysis_table">
            <thead class="table-headers text-center align-center thead">
              <tr
                v-for="(dat, idx) in tableFormat"
                :key="idx"
                :style="{
                  'background-color': dat['back'],
                }"
              >
                <template>
                  <th
                    :style="{
                      'border-bottom': '1px solid ' + dat['bdr'],
                    }"
                  >
                    {{ dat.label }}
                  </th>
                  <template v-if="dat.isHeader">
                    <td
                      v-for="(item, index) in dat.fieldNames"
                      :key="index"
                      :style="{
                        'border-bottom': '1px solid ' + dat['bdr'],
                      }"
                    >
                      <span>
                        {{
                          typeof item === "object"
                            ? dat.format(item.date)
                            : item
                        }}</span
                      >
                    </td>
                  </template>
                  <template v-else>
                    <td
                      v-for="(item, index) in dat.data"
                      :key="index"
                      :style="{
                        'border-bottom': '1px solid ' + dat['bdr'],
                      }"
                      :class="{
                        runModelTd:
                          isRunModel &&
                          item[dat.fieldNames[index]] === 'Run Model...',
                      }"
                    >
                      <span v-if="isCurrency">
                        {{ item[dat.fieldNames[index]] | formatCurr }}</span
                      >
                      <span v-else>
                        {{ item[dat.fieldNames[index]] | formatNum }}
                      </span>
                    </td>
                  </template>
                </template>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  colorExpo,
  colorExpoAlpha4,
  colorFwd,
  colorFwdAlpha2,
  currencyFormat,
  dateFormat,
} from "@/_core/_helpers/_parametric_tools";
import { format, timeFormat } from "d3";

export default {
  name: "tableForecastAnalysis",
  props: {
    commodityDefs: { required: true, default: "na" },
    colorTheme: { required: true, type: Boolean, default: true },
    dataTable: { required: true, default: () => [] },
    isCurrency: { required: false, type: Boolean, default: true },
    isRunModel: { required: false, type: Boolean, default: true },
    loadingModel: { required: false, type: Boolean, default: true },
  },
  data() {
    return {
      formatVars: {
        assetColor: colorExpo,
        assetBColor: colorExpoAlpha4,
        modelColor: colorFwd,
        modelBColor: colorFwdAlpha2,
        dateFormat: dateFormat,
      },
      data: {
        dateHeaders: [],
        dataAssets: [],
        dataModel: [],
      },
    };
  },
  computed: {
    dateValue() {
      return this.zoomedData[0] != null
        ? Object.keys(this.zoomedData[0]).indexOf("date") !== -1
          ? this.zoomedData[0]["date"]
          : "date"
        : "date";
    },
    tableFormat() {
      this.getDataTable();
      return [
        {
          back: "",
          bdr: "transparent",
          label: "Assets",
          fieldNames: this.data.dateHeaders,
          format: timeFormat(this.formatVars.dateFormat),
          isHeader: true,
        },
        {
          back: this.formatVars["assetBColor"](this.colorTheme),
          bdr: this.formatVars["assetColor"](this.colorTheme),
          fieldNames: ["close", "mean", "mean", "mean", "mean"],
          label: this.commodityDefs,
          format: this.isCurrency
            ? format(currencyFormat)
            : format(currencyFormat),
          data: this.data.dataAssets,
        },
        {
          back: this.formatVars["modelBColor"](this.colorTheme),
          bdr: this.formatVars["modelColor"],
          format: "",
          fieldNames: [
            "close",
            this.commodityDefs,
            this.commodityDefs,
            this.commodityDefs,
            this.commodityDefs,
          ],
          label: "MODEL",
          data: this.data.dataModel,
        },
      ];
    },
  },
  watch: {
    dataTable() {
      this.getDataTable();
    },
    isRunModel() {
      this.getDataTable();
    },
    loadingModel() {
      this.getDataTable();
    },
  },
  methods: {
    getDataTable() {
      this.data.dateHeaders = this.dataTable["dateHeaders"] || [];
      if (!this.data.dateHeaders.includes("Price")) {
        this.data.dateHeaders.unshift("Price");
      }
      this.data.dataAssets = this.dataTable["assetSelected"] || [];
      this.data.dataModel = this.dataTable["model"] || [];
      if (this.data.dataAssets.length === 1) {
        for (let i = 0; i < 4; i++) {
          this.data.dataAssets.push({ mean: "N/A" });
        }
      }

      if (this.data.dataModel.length === 1) {
        for (let i = 0; i < 4; i++) {
          this.data.dataModel.push({ [this.commodityDefs]: "Run Model..." });
        }
      }
    },
  },
  filters: {
    formatNum: function(value) {
      if (!Number.isNaN(value)) {
        return format(",.4r")(value);
      } else {
        return value;
      }
    },
    formatCurr: function(value) {
      if (!Number.isNaN(value)) {
        return format(currencyFormat)(value);
      } else {
        return value;
      }
    },
  },
};
</script>

<style>
table tr.div-prices th {
  background: var(--lightbackground-alpha);
}
.runModelTd {
  position: relative;
}

.runModelTd::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  background-size: 200% 100%;
  animation: loading 2s linear infinite;
  opacity: 0.6;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
@media (max-width: 1280px) {
  table tr th.text__quantities::after {
    top: 0%;
  }
}
</style>
